import React from 'react';

const SectionDivider = () => {
  return <div className='my-2 text-center text-xl font-light border-solid border-l-0 border-t-0 border-r-0 border-b border-sky-50 dark:border-sky-950' />;
};

export default SectionDivider;
